<!-- <iframe id="GeneratedVideo" width="420" height="315"
  [src]="videoPath">
  </iframe> -->
<div class="modal-header p-2 justify-content-end">
  <div class="form-row justify-content-end">
    <div class="col-md-auto col-auto border-0">
      <button class="btn btn-sm btn-main "
        style="background-color: rgb(29, 155,
        240); border-color:rgb(29, 155, 240);"
        (click)="payAndDownload()">Download Without Watermark</button>
    </div>
    <div class="col-md-auto col-auto" (click)="closeModal()">
      <span class="material-icons close-btn-mat cursor-pointer">
        close
      </span>
    </div>
  </div>
</div>
<!-- <div class="dialog-body">dialog-body -->
<div class="dialog-body how-its-works-pdf">
  <div *ngIf="invitationType==1">
    <video class="video-preivew z-depth-1" autoplay controls
      controlsList="nodownload" [style]="previewStyle">
      <source id="GeneratedVideo" src="{{videoPath}}" type="video/mp4" />
    </video>
    <div class="user-note">
      <p> Please note, this preview video is low quality and intended for
        illustration purposes only. The actual video you receive after payment
        will be of very high quality.</p>
    </div>
  </div>
  <!-- <pdf-viewer [src]="documentPath" *ngIf="invitationType==2"
    [render-text]="true"
    [original-size]="false" [show-all]="true"
    style="width: 400px; height: 500px"></pdf-viewer> -->
  <!-- <embed [src]="safeDocumentPath" width="800px" height="800px"
    *ngIf="invitationType==2"/> -->

  <!-- <embed
    [src]="safeDocumentPath"
    type="application/pdf"
    title="psd" /> -->

  <div
    [class]="displayType==2?'envelope-pdf-verticle':'envelope-pdf'"
    *ngIf="invitationType==2">
    <div class="envelope-header">Preview Demo Card</div>
    <div class="pdf-container">
      <div class="d-block d-md-none">
        <pdf-viewer
          [src]="documentPath"
          [rotation]="0"
          [original-size]="false"
          [show-all]="true"
          [fit-to-page]="false"
          [zoom]="1"
          [zoom-scale]="'page-width'"
          [stick-to-page]="false"
          [render-text]="true"
          [external-link-target]="'blank'"
          [autoresize]="true"
          [show-borders]="false"
          style="width: 100%; height: 100vh;"></pdf-viewer>
      </div>
      <div #pdfViewer class="d-none d-md-block"></div>

    </div>
  </div>

</div>